module.exports = __webpack_public_path__ + "media/images/background_identity_big-4b939cc9.jpg";